import React, { Fragment, useRef, useState } from "react";

const CslfComponent = (props) => {
  const { csLogData, cslfSearchValue, setCslfSearchValue, searchValues } = props;
  const logTableHeaders = ["id", "log_file_name", "log_time_ist", "log_type", "log", "created_at_ist"];
  const [cslfCurrentMatchIndex, setCslfCurrentMatchIndex] = useState(-1);
  const cslfCellRefs = useRef([]);

  const beautifyText = (text) => {
    return text.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  }

  const cslfFilteredData = csLogData?.filter((row) =>
    logTableHeaders.every((key) =>
      row[key] !== null ? row[key]?.toString().toLowerCase().includes(searchValues[key]?.toLowerCase() || "") : 'null'
    )
  );

  const onCslfSearchValueChange = (e) => {
    setCslfSearchValue(e.target.value);
  }

  const onCslfSearchKeyDown = (e) => {
    if (e.key === "Enter" && cslfSearchValue.trim() !== "") {
      const matches = [];
      const searchValue = cslfSearchValue.toLowerCase();

      // Highlight all matches
      cslfFilteredData.forEach((row, rowIndex) => {
        logTableHeaders.forEach((key, colIndex) => {
          const cellValue = row[key]?.toString() || "";

          // find matches and wrap in span
          const targetCell = cslfCellRefs.current[`${rowIndex}-${colIndex}`];
          if (targetCell){
            const highlightedHtml = cellValue.replace(
              new RegExp(searchValue, "gi"),
              (match) => `<span class="bg-warning">${match}</span>`
            );
            targetCell.innerHTML = highlightedHtml;

            // Track all matches for navigation
            const cellMatches = [...targetCell.querySelectorAll("span.bg-warning")];
            cellMatches.forEach((match) => matches.push(match));
          }
        });
      });

      if (matches.length > 0) {
        // Navigate through matches
        const newIndex = (cslfCurrentMatchIndex + 1) % matches.length;
        setCslfCurrentMatchIndex(newIndex);

        matches.forEach((match, index) => {
          match.classList.toggle("bg-danger", index === newIndex);
        });

        const currentMatch = matches[newIndex];
        currentMatch.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
    }
  };

  return (
    <Fragment>
      <div
        className="border border-success border-1 rounded-2 border-opacity-25 p-2"
        style={{ height: '440px', overflow: 'hidden', backgroundColor: '#ecf2ea'}}
      >
        <div className="d-flex">
          <div className="w-100">
            <h6 className="text-success text-center">CHARGING STATION LOG FILE</h6>
          </div>
          <div className="flex-shrink-1 p-1">
            <input
              id="cslfSearchValue"
              placeholder={`Search`}
              onChange={(e) => onCslfSearchValueChange(e)}
              onKeyDown={onCslfSearchKeyDown}
              value={cslfSearchValue}
              className="s-round-input"
              type="text"
              style={{
                padding: '10px 50px 10px 15px',
                height: '30px',
                width: '140px',
                fontSize: '12px'
              }}
            />
          </div>
        </div>
        <div
          className="table-responsive custom-scrollbar border"
          style={{ height: '90%', overflowY: 'auto' }}
        >
          <table className="table align-top table-sm table-borderless">
            <thead className="table-light" style={{ position: 'sticky', top: '0' }}>
              <tr>
                {logTableHeaders.map((key) => (
                  <th key={key} scope="col" style={{ minWidth: '100px' }}>
                    {beautifyText(key)}
                  </th>
                ))}
              </tr>
              <tr>
                {logTableHeaders.map((key) => (
                  <th key={key}>
                    <input
                      type="text"
                      className="form-control form-control-sm font-size-12"
                      placeholder={`Search ${key}`}
                      onChange={(e) => props.handleSearchChange(e, key)}
                      value={searchValues[key] || ""}
                    />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {cslfFilteredData?.length > 0 ? (
                cslfFilteredData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {logTableHeaders.map((key, colIndex) => (
                      <td
                        key={key}
                        className="border"
                        ref={(el) => (cslfCellRefs.current[`${rowIndex}-${colIndex}`] = el)}
                        style={{
                          maxWidth: '350px',
                          whiteSpace: 'normal',
                          wordWrap: 'break-word',
                          // wordBreak: 'break-word'
                        }}
                      >
                        {row[key]}
                      </td>
                    ))}
                  </tr>
                  ))
                ) : (
                <tr>
                  <td colSpan={logTableHeaders.length} className="text-center">
                    No matching records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  )
}

export default CslfComponent;
